// extracted by mini-css-extract-plugin
module.exports = {"container":"OfferBanner_fasting_container__2iJe2","icon":"OfferBanner_fasting_icon__EJT4O","link":"OfferBanner_fasting_link__3aZuf"};